import React from 'react';
import { PageContext } from '@contexts/page-context';

// this is used to differentiate en / es / en-in, use useCurrentLanguage to differentiate en / en-in
const useCurrentLanguage = () => {
  const { pageProps } = React.useContext(PageContext);
  let currentLanguage = '';
  if (pageProps?.pageContext?.additionalLanguage) {
    currentLanguage = pageProps?.pageContext?.additionalLanguage;
  } else {
    const currentBuild = process.env.REACT_APP_CURRENT_BUILD;
    currentLanguage = currentBuild;
  }

  const isEn = currentLanguage === 'en';
  const isEs = currentLanguage === 'es';
  const isEnIn = currentLanguage === 'en-in';

  // inLanguage is used for SEO purposes and it should be language dependant
  // TODO remove InLanguage if it's no longer needed in SEO
  let inLanguage = 'en-us';
  if (currentLanguage === 'es') {
    inLanguage = 'es-ES';
  }
  if (currentLanguage === 'en-in') {
    inLanguage = 'en-IN';
  }

  return { inLanguage, currentLanguage, isEn, isEs, isEnIn };
};

export default useCurrentLanguage;
